import { Button, Modal } from "antd";
import React, { useState, useEffect } from "react";

const Modal_v2 = ({
    className,
    content,
    children,
    onCancel,
    ...rest
}) => {
    // Handle ESC key press explicitly
    useEffect(() => {
        const handleEscKeyPress = (event) => {
            if (event.key === 'Escape' && rest.visible && onCancel) {
                onCancel(event);
            }
        };

        document.addEventListener('keydown', handleEscKeyPress);
        
        return () => {
            document.removeEventListener('keydown', handleEscKeyPress);
        };
    }, [rest.visible, onCancel]);

    return (
        // <div className="modal-comp">
            <Modal
                className={`modal-v2 ${className}`}
                onCancel={onCancel}
                keyboard={true} // Ensure keyboard (ESC) events are handled
                {...rest}
            >
                {content || children}
            </Modal>
        // </div>
    )
}

export default Modal_v2;